import { PalmettoIcon, PalmettoTooltip, PalmettoTooltipPosition } from '@palmetto/dsm-components';
import classNames from 'classnames';
import { useState } from 'react';
import { Button } from '../Button/Button';

export interface InfoPopoverProps {
  className?: string;
  content: string;
  placement?: PalmettoTooltipPosition;
}

export const InfoPopover = ({ className, content, placement = 'top-center' }: InfoPopoverProps): JSX.Element => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <PalmettoTooltip
      content={content}
      position={placement}
      open={isOpen}
      onOpenChange={({ open }) => setIsOpen(open)}
      closeOnPointerDown={false}
      className="max-w-xs"
    >
      <Button
        type="button"
        onClick={() => setIsOpen((prev) => !prev)}
        trackingId="info-popover"
        emphasis="tertiary"
        size="xs"
        className="py-4 px-4"
      >
        <PalmettoIcon name="infoSquare" className={classNames('text-icon-secondary', className)} />
      </Button>
    </PalmettoTooltip>
  );
};
